<template>
    <dv-border-box-12 class="item-container">
        <div class="btns2">
          <button @click="onTab(0)" :class="{ 'btn-active': type == 0 }">全部</button>
          <button @click="onTab(1)" :class="{ 'btn-active': type == 1 }">标准</button>
          <button @click="onTab(2)" :class="{ 'btn-active': type == 2 }">废油</button>
          <button @click="onTab(3)" :class="{ 'btn-active': type == 3 }">金属</button>
        </div>
        <vxe-table ref="xTable" highlight-hover-row height="85%" border="none" class="mytable-scrollbar" :filter-config="{ showIcon: false }" :data="enteriseList"
            @cell-click="cellClickEvent" @cell-dblclick="cellDBLClickEvent">
            <vxe-table-column type="seq" width="40"></vxe-table-column>
            <vxe-table-column field="name" type="html" :filters="[{ data: '' }]" :filter-method="customStringFilterMethod">
                <template #header="{ column }">
                    <vxe-input type="text" v-for="(option, index) in column.filters" :key="index" v-model="option.data" @change="filterEvent(option)" placeholder="请输入企业名称"
                        clearable></vxe-input>
                </template>
            </vxe-table-column>
        </vxe-table>
    </dv-border-box-12>
</template>

<script>

import EventBus from '../js/event-bus.js'
import XEUtils from 'xe-utils'
import remarkIcon2 from '../../assets/image/icon-marker2.png'
import remarkIcon3 from '../../assets/image/icon-marker3.png'
import remarkIcon4 from '../../assets/image/icon-marker4.png'
import remarkIcon5 from '../../assets/image/icon-marker5.png'

export default {
  name: 'EnteriseList',
  data () {
    return {
      imgObj: {
        remarkIcon2,
        remarkIcon3,
        remarkIcon4,
        remarkIcon5
      },
      list: [],
      enteriseList: [],
      type: 0
    }
  },
  created () {
    this.$api.getOrganizationsForMap()
      .then((res) => {
        if (!res) return
        this.list = res.data
        this.enteriseList = res.data.slice()
      })
      .catch((error) => {
        console.log(error)
      })

    EventBus.$on('freshEnterpriseList', (row) => {
      var item = this.enteriseList.find(
        (x) => x.organizationId === row.organizationId
      )
      if (item) {
        var index = item.name.indexOf('<img')
        if (index > -1) {
          item.name = item.name.slice(0, index)
        }
        item['icon1'] =
                    row.bodySensorStatus === 1
                      ? "<img src='../../assets/image/icon-marker2.png' title='人体检测' style='margin-left:5px' />"
                      : ''

        item['icon2'] =
                    row.doorSensorStatus === 1
                      ? "<img src='../../assets/image/icon-marker3.png' title='门禁打开' style='margin-left:5px' />"
                      : ''

        item.name += item.icon1 ? item.icon1 : ''
        item.name += item.icon2 ? item.icon2 : ''
        item.name += item.icon3 ? item.icon3 : ''
        item.name += item.icon4 ? item.icon4 : ''

        const xTable = this.$refs.xTable
        xTable.updateData()
      }
    })
  },
  methods: {
    cellClickEvent ({ row }) {
      EventBus.$emit('enteriseClickEvent', row)
    },
    cellDBLClickEvent ({ row }) {
      EventBus.$emit('enteriseDblClickEvent', row)
    },
    customStringFilterMethod ({ option, row, column }) {
      if (!option.data) return true
      return XEUtils.toValueString(row[column.property]).toLowerCase().includes(option.data)
    },
    filterEvent (option) {
      // 设置为选中状态
      option.checked = true
      // 修改条件之后，需要手动调用 updateData 处理表格数据
      this.$refs.xTable.updateData()
    },
    onTab (i) {
      this.type = i// data = data.map((d, i) => ({ ...d, scroll: i }));
      switch (i) {
        case 1:
          this.enteriseList = this.list.filter(e => !e.iotType.includes(9) && !e.iotType.includes(10))
          break
        case 2:
          this.enteriseList = this.list.filter(e => e.iotType.includes(9))
          break
        case 3:
          this.enteriseList = this.list.filter(e => e.iotType.includes(10))
          break
        default:
          this.enteriseList = this.list.slice()
          break
      }
    }
  }
}
</script>

<style lang="less">
.btns2{margin-bottom: 10px;}
.item-container {
    .border-box-content {
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }

    .item-title {
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        text-indent: 20px;
        margin: 10px 0;
    }

    #scroll-board {
        box-sizing: border-box;
        height: 100%;
        overflow: hidden;
    }

    .vxe-input--inner {
        color: #cce2fc;
    }
    .vxe-input.is--suffix .vxe-input--inner {
        padding: 0 10px;
    }
    .vxe-table--render-default .vxe-body--column:not(.col--ellipsis) {
        padding: 7px 0 !important;
    }
    .vxe-table--render-default.border--none .vxe-table--header-wrapper {
        background-color: rgba(10, 29, 50, 0.4) !important;
        border-bottom: 1px solid #242aa3 !important;
    }
    /* table */
    //header
    .vxe-table--header-wrapper,
    .vxe-header--row,
    .vxe-table--header {
        background-color: rgba(10, 29, 50, 0.4) !important;
        color: #cce2fc;
        font-size: 14px;
    }

    //body
    .vxe-table .vxe-table--body-wrapper {
        background-color: rgba(10, 29, 50, 0.4) !important;
        color: #cce2fc;
        font-size: 13px;
        cursor: pointer;
    }

    .vxe-table--render-default .vxe-table--body-wrapper,
    .vxe-table--render-default .vxe-table--footer-wrapper {
        background-color: rgba(10, 29, 50, 0.4) !important;
    }
    //行样式
    .vxe-table--render-default .vxe-body--row {
        background-color: rgba(10, 29, 50, 0.4) !important;
        color: #cce2fc;
    }
    /*表格搜索框*/
    .vxe-input.is--suffix .vxe-input--inner {
        padding-right: 1.8em;
        background-color: rgba(10, 29, 50, 0.4) !important;
        border: 1px solid #2e6099;
    }

    //hover
    .vxe-body--row.row--hover {
        background-color: #242aa3 !important;
        opacity: 1;
        color: #cce2fc;
    }
}
</style>
